/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

class ExternalFile extends Backbone.Model {
  static initClass() {
    this.prototype.urlRoot = '/1/api/external-files';
  }

  availablePreviewTypes() {
    return this.get('availablePreviewTypes');
  }

  externalFileURL() {
    return this.get('url');
  }

  externalFileId() {
    return this.get('id');
  }

  previewType() {
    return this.get('previewType');
  }

  static toName({url}) {
    return url.split('/').pop();
  }
}
ExternalFile.initClass();

export default ExternalFile;
